// @ts-nocheck

import { Map as LeafletMapType, Util } from 'leaflet';
import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';

/**
 * Patches Leaflet map method "locate" and "stopLocate" in leaflet-src.js to use Capacitor geolocation method instead of WorkerNavigator.
 * Applied only for native platforms - ios & android.
 * @param leafletMap
 */
export const patchLeafletMapLocateMethodIfIsNativeApp = (leafletMap: LeafletMapType) => {
    if (!Capacitor.isNativePlatform()) {
        return;
    }

    leafletMap.locate = LeafletLocateMethodPatchedWithIonicCapacitorLocator;
    leafletMap.stopLocate = LeafletStopLocateMethodPatchedWithIonicCapacitorStopWatch;
};

function LeafletLocateMethodPatchedWithIonicCapacitorLocator(options) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;

    options = self._locateOptions = Util.extend(
        {
            timeout: 10000,
            watch: false,
            enableHighAccuracy: true
        },
        options
    );

    const onResponse = Util.bind(self._handleGeolocationResponse, self),
        onError = Util.bind(self._handleGeolocationError, self);

    Geolocation.checkPermissions()
        .then((permission) => {
            if (permission.location === 'granted') {
                locateWithCapacitor.call(self, options, onResponse, onError);
            } else {
                Geolocation.requestPermissions().then((newPermission) => {
                    if (newPermission.location === 'granted') {
                        locateWithCapacitor.call(self, options, onResponse, onError);
                    } else {
                        onError({ message: 'location access not allowed' });
                    }
                });
            }
        })
        .catch(() => {
            onError({ message: 'failed to solve location permissions' });
        });

    return self;
}

function locateWithCapacitor(options, onResponse, onError) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    if (options.watch) {
        Geolocation.watchPosition(options, (pos) => {
            if (pos?.coords) {
                onResponse(pos);
            } else {
                onError({ message: 'position unavailable from capacitor watch position' });
            }
        }).then(
            (callBackId) => (self._locationWatchId = callBackId),
            (err) => onError(err)
        );
    } else {
        Geolocation.getCurrentPosition(options).then(
            (resp) => onResponse(resp),
            (err) => onError(err)
        );
    }
}

function LeafletStopLocateMethodPatchedWithIonicCapacitorStopWatch() {
    if (this._locationWatchId) {
        Geolocation.clearWatch({ id: this._locationWatchId });
    }
    if (this._locateOptions) {
        this._locateOptions.setView = false;
    }
    return this;
}
